import { render, staticRenderFns } from "./BatchApprovalDialog.vue?vue&type=template&id=6f8b046a"
import script from "./BatchApprovalDialog.vue?vue&type=script&lang=js"
export * from "./BatchApprovalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports